<template>
  <div>
    <titulo-modulo :titulo="titulosPage()" />
    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <template v-else>
      <v-card flat class="rounded-lg mt-2">
        <v-card-text>
          <v-select
            label="Plano selecionado"
            :items="getPlanosSelecionar()"
            item-text="descricao"
            item-value="codigo"
            v-model="planoSelecionadoModel"
            @change="recalcularSimulacao()"
          ></v-select>
          <btn-confirmar-alter-plano v-if="meuPlano && podeAlterarIncluir" />
          <btn-solicitar-plano v-else-if="podeAlterarIncluir" />
        </v-card-text>
      </v-card>
      <v-row dense>
        <v-col
          v-if="meuPlano != null"
          :cols="isMobile() ? 12 : 6"
          class="pt-1 pb-1"
        >
          <v-card flat class="mt-2 rounded-lg">
            <v-card-title class="font-weight-bold subtitle-2 pb-0"
              >Valores plano atual</v-card-title
            >
            <v-card-text>
              <v-row dense>
                <v-col xl="auto" lg="auto" md="auto" cols="12">
                  <v-card flat>
                    <v-card-subtitle class="pb-0 mb-0"
                      >Valor total do plano</v-card-subtitle
                    >
                    <v-card-title class="font-weight-bold pt-1 mb-0 pb-0">
                      <s>
                        {{ formatarMoeda(meuPlano.vlrtotalplano) }}</s
                      ></v-card-title
                    >
                  </v-card>
                </v-col>
                <v-col xl="auto" lg="auto" md="auto" cols="12">
                  <v-card flat>
                    <v-card-subtitle class="pb-0"
                      >A Coasul paga</v-card-subtitle
                    >
                    <v-card-title
                      class="font-weight-bold blue--text pt-1 mb-0 pb-0"
                      ><s>{{
                        formatarMoeda(meuPlano.vlrtotalcoasul)
                      }}</s></v-card-title
                    >
                  </v-card>
                </v-col>
                <v-col xl="auto" lg="auto" md="auto" cols="12">
                  <v-card flat>
                    <v-card-subtitle class="pb-0"
                      >O colaborador paga</v-card-subtitle
                    >
                    <v-card-title class="font-weight-bold green--text pt-1"
                      ><s>{{
                        formatarMoeda(meuPlano.vlrtotalfunc)
                      }}</s></v-card-title
                    >
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          :cols="isMobile() || meuPlano == null ? 12 : 6"
          class="pt-1 pb-1"
        >
          <v-card flat class="mt-2 rounded-lg">
            <v-card-title class="font-weight-bold subtitle-2 pb-0">{{
              meuPlano ? "Valores para o novo plano" : "Valores simulados"
            }}</v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col xl="auto" lg="auto" md="auto" cols="12">
                  <v-card flat>
                    <v-card-subtitle class="pb-0 mb-0"
                      >Valor total do plano</v-card-subtitle
                    >
                    <v-card-title class="font-weight-bold pt-1 mb-0 pb-0">{{
                      formatarMoeda(valorescalculados.vlrplano)
                    }}</v-card-title>
                  </v-card>
                </v-col>
                <v-col xl="auto" lg="auto" md="auto" cols="12">
                  <v-card flat>
                    <v-card-subtitle class="pb-0"
                      >A Coasul paga</v-card-subtitle
                    >
                    <v-card-title
                      class="font-weight-bold blue--text pt-1 mb-0 pb-0"
                      >{{
                        formatarMoeda(valorescalculados.vlrpagocoasul)
                      }}</v-card-title
                    >
                  </v-card>
                </v-col>
                <v-col xl="auto" lg="auto" md="auto" cols="12">
                  <v-card flat>
                    <v-card-subtitle class="pb-0"
                      >O colaborador paga</v-card-subtitle
                    >
                    <v-card-title class="font-weight-bold green--text pt-1">{{
                      formatarMoeda(valorescalculados.vlrpagofunc)
                    }}</v-card-title>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-card flat class="mt-2 rounded-lg">
        <v-card-title class="subtitle-2 font-weight-bold">{{
          meuPlano ? "Dependentes do plano" : "Dependentes disponíveis"
        }}</v-card-title>
        <v-card-text>
          <v-data-table
            hide-default-footer
            :items="dependentesSelecionar()"
            :headers="headers"
            :header-props="headers_prop"
            no-data-text="Nenhum dependente encontrado"
            disable-sort
          >
            <template v-slot:[`item.selecionado`]="{ item }">
              <v-switch
                :disabled="item.codigo == 0 || meuPlano != null"
                dense
                inset
                v-model="item.selecionado"
                @change="recalcularSimulacao()"
              ></v-switch>
            </template>
            <template v-slot:[`item.parentesco`]="{ item }">
              <v-chip
                x-small
                dark
                :color="item.codigo == 0 ? 'green' : 'grey'"
                >{{ item.parentesco }}</v-chip
              >
            </template>
            <template v-slot:[`item.vlrplano`]="{ item }">
              {{ formatarMoeda(item.vlrplano) }}
            </template>
            <template v-slot:[`item.vlrpagocoasul`]="{ item }">
              <span class="blue--text font-weight-bold subtitle-1">{{
                item.vlrpagocoasul >= 0
                  ? formatarMoeda(item.vlrpagocoasul)
                  : "R$ ---"
              }}</span>
            </template>
            <template v-slot:[`item.vlrpagofunc`]="{ item }">
              <span class="green--text font-weight-bold subtitle-1">{{
                item.vlrpagofunc >= 0
                  ? formatarMoeda(item.vlrpagofunc)
                  : "R$ ---"
              }}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import TituloModulo from "../../../components/TituloModulo.vue";
import { formatMoeda } from "@/global";
import BtnSolicitarPlano from "../buttons/BtnSolicitarPlano.vue";
import BtnConfirmarAlterPlano from "../buttons/BtnConfirmarAlterPlano.vue";

export default {
  components: { TituloModulo, BtnSolicitarPlano, BtnConfirmarAlterPlano },
  computed: {
    ...mapState("planoSaude", [
      "planos",
      "planoSelecionado",
      "meuPlano",
      "simulador",
      "filtroSimulador",
      "podeAlterarIncluir",
    ]),
    planoSelecionadoModel: {
      get: function () {
        return this.planoSelecionado;
      },
      set: function (value) {
        return this.setPlanoSelecionado(value);
      },
    },
  },
  data: () => ({
    loading: true,
    recalculando: false,
    valorescalculados: {
      vlrplano: 0,
      vlrpagofunc: 0,
      vlrpagocoasul: 0,
    },
    headers: [
      { text: "Selecionar", value: "selecionado" },
      { text: "Dependente", value: "nome" },
      { text: "Parentesco", value: "parentesco" },
      { text: "Plano", value: "descplano" },
      { text: "Valor plano", value: "vlrplano" },
      { text: "Coasul paga", value: "vlrpagocoasul" },
      { text: "Colaborador paga", value: "vlrpagofunc" },
    ],
    headers_prop: {
      "disable-sort": true,
    },
  }),
  methods: {
    ...mapMutations("planoSaude", ["setPlanoSelecionado"]),
    ...mapActions("planoSaude", [
      "getPlanos",
      "getSimulador",
      "getConfigDocs",
      "getMeuPlano",
    ]),
    ...mapGetters("planoSaude", ["getterPlanoSelecionado"]),
    async recalcularSimulacao() {
      this.recalculando = true;
      this.filtroSimulador.codplano = this.planoSelecionado;
      this.filtroSimulador.dependentes = [];

      const dependentesSelecionados =
        this.getterPlanoSelecionado().dependentes.filter((d) => d.selecionado);

      dependentesSelecionados.forEach((dep) => {
        this.filtroSimulador.dependentes.push(dep.codigo);
      });

      await this.getSimulador();

      this.calcularPlano();

      this.recalculando = false;
    },
    formatarMoeda(value) {
      return formatMoeda(value);
    },
    isMobile() {
      return this.$mq == "sm";
    },
    calcularPlano() {
      this.valorescalculados.vlrplano = 0;
      this.valorescalculados.vlrpagocoasul = 0;
      this.valorescalculados.vlrpagofunc = 0;

      this.getterPlanoSelecionado()
        .dependentes.filter((d) => d.selecionado)
        .forEach((dep) => {
          this.valorescalculados.vlrplano += dep.vlrplano;
          this.valorescalculados.vlrpagocoasul += dep.vlrpagocoasul;
          this.valorescalculados.vlrpagofunc += dep.vlrpagofunc;
        });
    },
    titulosPage() {
      return this.meuPlano ? "Trocar Plano de Saúde" : "Simular Plano de Saúde";
    },
    selecionarDependentesPossuemPlano() {
      this.simulador.forEach((s) => {
        s.dependentes
          .filter(
            (d) =>
              this.meuPlano.dependentes.findIndex(
                (dep) => dep.codigo == d.codigo && dep.possuiplano
              ) >= 0
          )
          .forEach((s) => {
            s.selecionado = true;
          });
      });
    },
    getPlanosSelecionar() {
      if (this.meuPlano) {
        return this.planos.filter((p) => p.codigo != this.meuPlano.codplano);
      }
      return this.planos;
    },
    dependentesSelecionar() {
      if (this.meuPlano != null) {
        const dependentesFiltrados =
          this.getterPlanoSelecionado().dependentes.filter(
            (d) =>
              this.meuPlano.dependentes.findIndex(
                (dep) => dep.codigo == d.codigo && dep.possuiplano
              ) >= 0
          );

        return dependentesFiltrados;
      }

      const todosDependentes = this.getterPlanoSelecionado().dependentes;

      return todosDependentes;
    },
  },
  async created() {
    this.loading = true;

    await this.getPlanos();

    await this.getSimulador();

    await this.getMeuPlano();

    await this.getConfigDocs();

    if (this.meuPlano != null) {
      this.selecionarDependentesPossuemPlano();
      this.setPlanoSelecionado(this.getPlanosSelecionar()[0].codigo);
    }

    this.calcularPlano();

    this.loading = false;
  },
};
</script>

<style></style>
